import React from 'react';
import Firstgrade_k1 from './firstgrade_k1';
import Firstgrade_k1_subjects from './firstgrade_k1_subjects';
const Firstgrade_k1math = () => {
  return (
    <div>
      <Firstgrade_k1 />
    <Firstgrade_k1_subjects />
    <div className='relative right-0 left-0 top-37 '>
      <h1>English section</h1>
      <h3>English section in the curriculum</h3>
      <li>Generic skills or Soft skills or 21st century skills integrated in agriculture learning and assessment </li>
      <li>Cross-cutting isues integrated in Agriculture learning and assessment </li>
      <li>Values integrated in Agriculture learning and assessment </li>
      </div>
    </div>
  );
}

export default Firstgrade_k1math;